export default __webpack_public_path__ + "static/media/Ellipse.917d0244.svg";